import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["label"];
import React from 'react';
import CrossIcon from '@atlaskit/icon/core/cross';
import LegacyCloseIcon from '@atlaskit/icon/glyph/editor/close';
import { StyledClearButton } from './styled';
export var ClearButton = function ClearButton(_ref) {
  var label = _ref.label,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(StyledClearButton, _extends({}, props, {
    "data-testid": "paginated-picker.ui.clear-button"
  }), /*#__PURE__*/React.createElement(CrossIcon, {
    color: "currentColor",
    label: label,
    LEGACY_fallbackIcon: LegacyCloseIcon,
    LEGACY_margin: "0 0 0 -6px",
    size: "small"
  }));
};
ClearButton.defaultProps = {
  isSelected: false,
  type: 'button'
};
export default ClearButton;